/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {

	const mainVisSwiper = () => {
		// const videoDelayTime = (FUNCTIONS.va.region === '/jp/') ? 11000 : 8000;
		const videoDelayTime = 8000;
		const swiper = new Swiper('.mod-mainVisSlider.swiper', {
			slidesPerView: 1,
			spaceBetween: 0,
			loop: true,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			speed: 900,
			autoplay: {
				delay: videoDelayTime,
				disableOnInteraction: false
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			on: {
				transitionStart: () => {
					if (FUNCTIONS.va.window.width >= FUNCTIONS.va.device.sp) {
						let videos = document.querySelectorAll('.mod-mainVisSlider video');
						Array.prototype.forEach.call(videos, (video) => {
							video.pause();
						});
					}
				},
				transitionEnd: function () {
					if (FUNCTIONS.va.window.width >= FUNCTIONS.va.device.sp) {
						let activeIndex = this.activeIndex;
						let activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
						if (activeSlide.getElementsByTagName('video').length) {
							let activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
							activeSlideVideo.play();
						}
					}
				}
			}
		});
	};

	mainVisSwiper();

})(window.FUNCTIONS);
